import gql from "graphql-tag";
import {
  ProductInfo_productInfo,
  ProductInfo as ProductInfoT
} from "@/models/queries/types/ProductInfo";

export const QUERY_PRODUCT_INFO = gql`
  query ProductInfo {
    productInfo {
      id
      name
      shortcut
      isDropdown
      allowsMultiple
      isRequired
      hasCustomValues
      values {
        id
        name
      }
    }
  }
`;

export type ProductInfo = ProductInfo_productInfo;
export type ProductInfoResult = ProductInfoT;
